module.exports = __webpack_public_path__ + "static/DylanA-a56076ed794b46257ba407c391139dac.jpg";